export default __webpack_public_path__ + "static/media/steps.f560d7be.svg";